/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Promo_Show_RetiredInputs */



/**
* | output |
* | --- |
* | "Show retired" |
*
* @param {Promo_Show_RetiredInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const promo_show_retired = /** @type {((inputs?: Promo_Show_RetiredInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Promo_Show_RetiredInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher les retirées")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar retiradas")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Mostrar retiradas")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra ritirate")
	return /** @type {LocalizedString} */ ("Show retired")
});